import type { OsWindow } from "@/components/ui/os-layout/OsContext";

export type AgentFocusParams = {
  focusKey: string | null;
  focusSeq: string | null;
};

export function readAgentFocusParams(
  osWindow: Pick<OsWindow, "params" | "focusNonce"> | null | undefined,
  searchParams: URLSearchParams | { get: (key: string) => string | null },
): AgentFocusParams {
  const get = (key: string) => {
    const fromWindow = osWindow?.params?.[key];
    if (fromWindow) return fromWindow;
    return searchParams.get(key);
  };
  const focusKey = get("focus")?.trim() || null;
  const focusSeq =
    osWindow?.focusNonce != null
      ? String(osWindow.focusNonce)
      : searchParams.get("focusSeq")?.trim() || null;
  return { focusKey, focusSeq };
}

export function entityIdFromFocusKey(
  focusKey: string | null | undefined,
  expectedPrefix: string,
): string | null {
  if (!focusKey?.startsWith(`${expectedPrefix}:`)) {
    return null;
  }
  const id = focusKey.slice(expectedPrefix.length + 1).trim();
  return id || null;
}
